const base64ToBytes = (value: string): Uint8Array => {
  const binaryString = atob(value);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
};

export const decodeBase64 = (value: string): string | null => {
  try {
    return new TextDecoder().decode(base64ToBytes(value));
  } catch {
    return null;
  }
};

// Returns the decoded string only if it's genuine text; null for binary. A lenient decode turns
// binary (e.g. PDF bytes) into replacement-character mojibake that still renders as garbled text,
// so we reject anything that isn't valid UTF-8 or that carries NUL / stray control bytes.
export const decodeBase64Strict = (value: string): string | null => {
  let text: string;
  try {
    text = new TextDecoder('utf-8', { fatal: true }).decode(base64ToBytes(value));
  } catch {
    return null;
  }
  for (const char of text) {
    const code = char.charCodeAt(0);
    const isAllowedControl = code === 0x09 || code === 0x0a || code === 0x0d; // tab, LF, CR
    if (code < 0x20 && !isAllowedControl) return null;
  }
  return text;
};
